import {
  CreateActivatorInteractionCommand,
  CreateJourneyActivatorCommand,
  ICreateActivatorInteractionCommand,
  ICreateJourneyActivatorCommand,
  ITutorialJourneyActivatorDto,
  ITutorialJourneyWithActivators,
  IUpdateJourneyActivatorCommand,
  UpdateJourneyActivatorCommand,
} from "@growth-machine-llc/stridist-api-client";
import { tutorialJourneyActivatorsClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";

class TutorialJourneyActivatorsService extends ServiceBase {
  async getTutorialJourneysActivators(): Promise<ITutorialJourneyWithActivators> {
    return tutorialJourneyActivatorsClient.getAllTutorialActivators();
  }

  async getTutorialJourneyActivatorById(
    id: number,
  ): Promise<ITutorialJourneyActivatorDto> {
    return tutorialJourneyActivatorsClient.getTutorialActivatorById(id);
  }

  async createActivatorInteraction(data: ICreateActivatorInteractionCommand) {
    const command = CreateActivatorInteractionCommand.fromJS(data);
    return tutorialJourneyActivatorsClient.createActivatorInteraction(command);
  }

  async createTutorialJourneyActivator(data: ICreateJourneyActivatorCommand) {
    const command = CreateJourneyActivatorCommand.fromJS(data);
    return tutorialJourneyActivatorsClient.createTutorialJourneyActivator(
      command,
    );
  }

  async updateJourneyActivator(data: IUpdateJourneyActivatorCommand) {
    const command = UpdateJourneyActivatorCommand.fromJS(data);
    return tutorialJourneyActivatorsClient.updateTutorialJourneyActivator(
      command.id,
      command,
    );
  }

  async deleteJourneyActivator(id: number) {
    return tutorialJourneyActivatorsClient.deleteJourneyActivator(id);
  }
}

export default new TutorialJourneyActivatorsService();
